import { NotificationItem } from '@ps-int/ps-components/src/notifications/slice';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';

import { NotificationType } from './types';

interface NotificationsState {
    items: NotificationItem[];
}

export const hideNotification = createAction<string>('@NOTIFICATIONS/hideNotification');
export const notify = createAction<NotificationItem>('@NOTIFICATIONS/notify');

const initialState: NotificationsState = {
    items: [],
};

const notificationsSlice = createSlice({
    name: '@NOTIFICATIONS',
    initialState,
    reducers: {
        addNotification(state: NotificationsState, action: PayloadAction<NotificationItem>) {
            const notification = {
                priority: 0,
                type: NotificationType.INFO,
                ...action.payload,
            };

            const addNotification = () => {
                if (notification.priority) {
                    const index = state.items.findIndex((item) => {
                        return (item.priority || 0) < notification.priority;
                    });
                    state.items.splice(index, 0, notification);
                } else {
                    state.items.push(notification);
                }
            };

            const existsIndex = state.items.findIndex(({ id }) => id === notification.id);
            if (existsIndex !== -1) {
                state.items.splice(existsIndex, 1, notification);
                return state;
            }

            if (notification.group) {
                const index = state.items.findIndex(({ group }) => group === notification.group);
                if (index !== -1) {
                    state.items.splice(index, 1, action.payload);
                } else {
                    addNotification();
                }
            } else {
                addNotification();
            }
        },
        removeNotification(state: NotificationsState, action: PayloadAction<string>) {
            state.items = state.items.filter(({ id }) => id !== action.payload);
        },
        clearNotifications(state: NotificationsState) {
            state.items = [];
        },
    },
});

export const { addNotification, removeNotification, clearNotifications } = notificationsSlice.actions;

export const psNotificationsReducer = notificationsSlice.reducer;
